import { render, staticRenderFns } from "./AddToCartFood.vue?vue&type=template&id=b435ea28&scoped=true&"
import script from "./AddToCartFood.vue?vue&type=script&lang=js&"
export * from "./AddToCartFood.vue?vue&type=script&lang=js&"
import style0 from "./AddToCartFood.vue?vue&type=style&index=0&id=b435ea28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b435ea28",
  null
  
)

export default component.exports